import React from 'react';
import FC from './FC'
import './FeaturedWork.css'


const FeaturedWork = () => {

return (
    <div className="Work">
<FC/>
    </div>
)


}




export default FeaturedWork;